import { WizardResultsGroupType } from '@wizard/wizard-results/types';

export const BreadcrumbGroups: WizardResultsGroupType[] = [
  'Reports',
  'Semantics',
  'Views'
];
